/* eslint-disable max-classes-per-file */
/* eslint-disable no-use-before-define */
import {
    MasterMessageHubInstance,
    MessageSourceKey,
    Observable,
    ObservableCreator,
    MessageSourceManager,
    PipeConfig,
} from '../interface';
import {
    RootPushSourceManager,
    PushSourceManager,
    PushMessageLikeObservable,
} from './pushSourceManager';
import { RootCustomSourceManager, CustomSourceManager } from './customSourceManager';

export class RootMasterMessageHub<PK extends MessageSourceKey, CK extends MessageSourceKey>
    implements MasterMessageHubInstance<PK, CK> {
    private pushSourceManager: RootPushSourceManager<PK>;

    private customSourceManager: RootCustomSourceManager<CK>;

    constructor(
        pushSourceManager: RootPushSourceManager<PK>,
        customSourceManager: RootCustomSourceManager<CK>,
    ) {
        this.pushSourceManager = pushSourceManager;
        this.customSourceManager = customSourceManager;
    }

    public usePushSource(source$: PushMessageLikeObservable) {
        return this.pushSourceManager.useSource(source$);
    }

    public getPushSource<T = any>(key: PK) {
        return this.pushSourceManager.getSource<T>(key);
    }

    public registerPushSource(key: PK) {
        return this.pushSourceManager.registerSource(key);
    }

    public useCustomSource<T = any>(key: CK, source: ObservableCreator<T>) {
        return this.customSourceManager.useSource<T>(key, source);
    }

    public getCustomSource<T = any>(key: CK): Observable<T> {
        return this.customSourceManager.getSource<T>(key);
    }

    public registerCustomSource(key: CK) {
        return this.customSourceManager.registerSource(key);
    }

    public pipe(
        config: Partial<{
            push: PipeConfig<PK>;
            custom: PipeConfig<CK>;
        }>,
    ): MasterMessageHubInstance<PK, CK> {
        return new MasterMessageHub(
            this.pushSourceManager.pipe(config.push),
            this.customSourceManager.pipe(config.custom),
        );
    }
}

export class MasterMessageHub<PK extends MessageSourceKey, CK extends MessageSourceKey>
    implements MasterMessageHubInstance<PK, CK> {
    private pushSourceManager: MessageSourceManager<PK>;

    private customSourceManager: MessageSourceManager<CK>;

    constructor(
        pushSourceManager: MessageSourceManager<PK>,
        customSourceManager: MessageSourceManager<CK>,
    ) {
        this.pushSourceManager = pushSourceManager;
        this.customSourceManager = customSourceManager;
    }

    public getPushSource<T = any>(key: PK) {
        return this.pushSourceManager.getSource<T>(key);
    }

    public registerPushSource(key: PK) {
        return this.pushSourceManager.registerSource(key);
    }

    public getCustomSource<T = any>(key: CK): Observable<T> {
        return this.customSourceManager.getSource<T>(key);
    }

    public registerCustomSource(key: CK) {
        return this.customSourceManager.registerSource(key);
    }

    public pipe(
        config: Partial<{
            push: PipeConfig<PK>;
            custom: PipeConfig<CK>;
        }>,
    ): MasterMessageHubInstance<PK, CK> {
        return new MasterMessageHub(
            this.pushSourceManager.pipe(config.push),
            this.customSourceManager.pipe(config.custom),
        );
    }
}

export { RootPushSourceManager, PushSourceManager, RootCustomSourceManager, CustomSourceManager };
